// Mappers for machine operation entities
// Identity mappers for 1:1 mapping

import type { SearchMachinesResponseDto } from '@api/generated/models';

import type { ScheduledOperationsResponse as ScheduledOperationsResponseLocal } from '@api/modules/machineOperation/types';

import type { SearchMachinesResponse, ScheduledOperationsResponse } from '@api/domain/types';

// Response mappers (identity for 1:1)
export const toSearchMachinesResponse = (dto: SearchMachinesResponseDto): SearchMachinesResponse => dto;

// Local type mappers (identity for 1:1)
export const toScheduledOperationsResponse = (dto: ScheduledOperationsResponseLocal): ScheduledOperationsResponse =>
  dto;
